import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Slider from "@material-ui/core/Slider";
import { stepPercentage } from "../config/stepPercentage";
import { Hidden } from "@material-ui/core";
import { useSelector } from "react-redux";
import { stepSelector } from "../store/engine/engine.selectors";

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.up("md")]: {
      width: "90%",
      position: "absolute", // see GridPanel "relative" parent as anchor
      top: -85,
    },
  },
}));

// il valore mostrato
const valueConverter = (value: number): string => {
  return `${value}%`;
};

export const Stepper: FC = () => {
  const classes = useStyles();
  const step = useSelector(stepSelector);

  return (
    <div className={classes.container}>
      <Slider
        key={step}
        defaultValue={stepPercentage[step]}
        getAriaValueText={valueConverter}
        aria-labelledby="discrete-slider-always"
        disabled
        step={null} // forza il passaggio SOLO fra marks definiti
        valueLabelDisplay="on"
        valueLabelFormat={valueConverter}
      />
      <Hidden only={["xs", "sm"]}>
        <Typography id="discrete-slider-always" gutterBottom>
          Completamento preventivo
        </Typography>
      </Hidden>
    </div>
  );
};
